exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".tanpawrap[data-v-2f45df62]{white-space:nowrap}", ""]);

// exports
